import React from 'react'

const ArrowRightSVG = () => {
  return (
    <>
      <svg
        width='12'
        height='11'
        viewBox='0 0 12 11'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M1.49316 5.5H9.49317'
          stroke='#FC6FBB'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M6.82617 9.5L10.8262 5.5L6.82617 1.5'
          stroke='#FC6FBB'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </>
  )
}

export default ArrowRightSVG
